import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface SectionProps {
  title: string;
  children: React.ReactNode;
  collapsible?: boolean;
  defaultOpen?: boolean;
  action?: React.ReactNode;
}

export function Section({ title, children, collapsible = false, defaultOpen = true, action }: SectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div style={{
      background: 'var(--glass-bg-card)',
      backdropFilter: 'blur(16px) saturate(140%)',
      WebkitBackdropFilter: 'blur(16px) saturate(140%)',
      border: '1px solid rgba(255, 255, 255, 0.10)',
      borderRadius: 'var(--radius-card)',
      overflow: 'hidden',
      marginBottom: '1.5rem',
      boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
    }}>
      <div
        style={{
          padding: '0.875rem 1.25rem',
          borderBottom: open ? '1px solid rgba(255, 255, 255, 0.08)' : 'none',
          cursor: collapsible ? 'pointer' : 'default',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '0.5rem',
        }}
        onClick={collapsible ? () => setOpen(o => !o) : undefined}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          {collapsible && (
            <ChevronDown
              size={14}
              style={{
                color: 'var(--color-text-muted)',
                transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
                transition: 'transform 0.15s',
              }}
            />
          )}
          <h3 style={{ fontSize: 'var(--text-sm)', fontWeight: 600, margin: 0 }}>{title}</h3>
        </div>
        {action}
      </div>
      {open && (
        <div style={{ padding: '1.25rem' }}>
          {children}
        </div>
      )}
    </div>
  );
}
